// Module
var code = "<descriptive-box title=download> <div class=description-content> <p translate=app.submitRequest.download.info></p> <fd-form-button btn-primary=true btn-block=true on-click=vm.download() is-busy=vm.isDownloadBusy icon=\"fa fa-download\" label=app.submitRequest.download> </fd-form-button> </div> </descriptive-box> ";
// Exports
var _module_exports = code;;
var path = 'app/components/tickets/create/receiving/submitRequest/partials/directBank/submitRequest.download.tpl.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;